import React from 'react';
// Custom thin line art SVG icons for R.I.S.E.
const iconProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: '1.2',
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  className: 'w-12 h-12'
};
export function EyeIcon() {
  return <svg {...iconProps} data-id="element-269" data-mp="1csbh7yia2ggp">
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" data-id="element-270" data-mp="1cu62jdxgoalb" />
      <circle cx="12" cy="12" r="3" data-id="element-271" data-mp="p30lwwjp5e9y" />
    </svg>;
}
export function FingerprintIcon() {
  return <svg {...iconProps} data-id="element-272" data-mp="k4fn91k3f2nm">
      <path d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4" data-id="element-273" data-mp="k58xici9gaai" />
      <path d="M14 13.12c0 2.38 0 6.38-1 8.88" data-id="element-274" data-mp="z1gel3ydgvlk" />
      <path d="M17.29 21.02c.12-.6.43-2.3.5-3.02" data-id="element-275" data-mp="z2817p9zrizp" />
      <path d="M2 12a10 10 0 0 1 18-6" data-id="element-276" data-mp="u2d9xkmb0re4" />
      <path d="M2 16h.01" data-id="element-277" data-mp="u1c0fkkxscyi" />
      <path d="M21.8 16c.2-2 .131-5.354 0-6" data-id="element-278" data-mp="u1265ksuzjn0" />
      <path d="M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2" data-id="element-279" data-mp="2ag3pbnivj232" />
      <path d="M8.65 22c.21-.66.45-1.32.57-2" data-id="element-280" data-mp="2aipw3kxxxdk8" />
      <path d="M9 6.8a6 6 0 0 1 9 5.2v2" data-id="element-281" data-mp="25ibmhygoxvk3" />
    </svg>;
}
export function AnchorIcon() {
  return <svg {...iconProps} data-id="element-282" data-mp="f9gbymvh08yo">
      <circle cx="12" cy="5" r="3" data-id="element-283" data-mp="f859qrhob99o" />
      <line x1="12" y1="22" x2="12" y2="8" data-id="element-284" data-mp="k7rnr35bstjj" />
      <path d="M5 12H2a10 10 0 0 0 20 0h-3" data-id="element-285" data-mp="k6p0d577p98d" />
    </svg>;
}
export function TrendingUpIcon() {
  return <svg {...iconProps} data-id="element-286" data-mp="p85w6maua5i3">
      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" data-id="element-287" data-mp="p4qgpid96ug5" />
      <polyline points="16 7 22 7 22 13" data-id="element-288" data-mp="t8pqzj7xwx12" />
    </svg>;
}